import { Box } from "@mui/material";
import { useSort } from "~/pages/inventory/hooks/useSort";
import { Header } from "~/components/FirewatchPage/FirewatchPageColumns";
import { FindingsTableSort } from "~/components/FirewatchList/components/FindingsTableSort";
import { Header as FindingTableHeader } from "~/types/table";

interface FindingsTablePreHeaderProps {
  sort?: ReturnType<typeof useSort>;
  isSortDisable?: boolean;
  sortableHeaders: Header[] | FindingTableHeader[];
}

export const FindingsTablePreHeader = ({
  sort,
  isSortDisable,
  sortableHeaders,
}: FindingsTablePreHeaderProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        width: "100%",
        mb: 1,
      }}
    >
      {!isSortDisable && sort && (
        <FindingsTableSort sort={sort} sortableHeaders={sortableHeaders} />
      )}
    </Box>
  );
};
